import { Serializable } from '../interfaces';

export enum PasoNombreEnum {
  DATOS_INICIALES = 'DATOS_INICIALES',
  DATOS_DE_FACTURA = 'DATOS_DE_FACTURA',
  ENCUESTA = 'ENCUESTA',
  SELECCION_COMUNIDAD = 'SELECCION_COMUNIDAD',
  ACCESO_DATADIS = 'ACCESO_DATADIS',
  CONTRATO_OTC = 'CONTRATO_OTC',
  ACEPTACION_OFERTAS = 'ACEPTACION_OFERTAS',
  FIRMA_CONTRATO_REPARTO = 'FIRMA_CONTRATO_REPARTO',
}
export interface MensajeRecordatoriosAPII {
  id: number;
  paso_nombre: PasoNombreEnum; // Enum: DATOS_INICIALES, DATOS_DE_FACTURA, etc.
  listado_recipientes_cc: string[];
  plantilla_texto_plano?: string;
  plantilla_html?: string;
}

export default class MensajeRecordatorios implements Serializable<MensajeRecordatorios> {
  id: number;

  pasoNombre: PasoNombreEnum;

  listadoRecipientesCc: string[];

  plantillaTextoPlano?: string;

  plantillaHtml?: string;

  deserialize(input: MensajeRecordatoriosAPII): MensajeRecordatorios {
    if (!input) return this;

    this.id = input.id;
    this.pasoNombre = input.paso_nombre;
    this.listadoRecipientesCc = input.listado_recipientes_cc;
    this.plantillaTextoPlano = input.plantilla_texto_plano;
    this.plantillaHtml = input.plantilla_html;

    return this;
  }

  // eslint-disable-next-line class-methods-use-this
  deserializeArray(inputArray: Array<MensajeRecordatoriosAPII>): Array<MensajeRecordatorios> {
    return inputArray.map((input) => new MensajeRecordatorios().deserialize(input));
  }
}
